<template>
  <div>
    <!--关联交易号 -->
    <el-dialog :title="$t('message.relatedTransactionNumber')" :close-on-click-modal="false"
      :visible.sync="$parent.relatedTransactionNumberDialogVisible" width="426px" center>
      <div class="content">
        <!-- 关联交易号 -->
        <div class="label">
          {{ $t("message.relatedTransactionNumber") }}
          ：
        </div>
        <div class="val">
          <el-input v-model="purchase_no" onfocus="this.select()"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.relatedTransactionNumberDialogVisible = false">{{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    express_no: { type: String },
  },
  data() {
    return {
      purchase_no: "",
    };
  },
  methods: {
    // 保存
    save() {
      if (this.purchase_no == "")
        return this.$message.error(
          this.$t("message.pleaseEnterTransactionNumber")
        );
      let datas = {
        express_no: this.express_no,
        purchase_no: this.purchase_no,
      };
      this.$api.signInApi.receiveRelationPurchaseNo(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.relatedTransactionNumberDialogVisible = false;
        this.$parent.receiveList();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 2.5;
  }
}
</style>